import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { buttonClasses, ButtonGroup as MuiButtonGroup, buttonGroupClasses, styled } from '@mui/material';
import { pxToRem } from '@themes';
var StyledButtonGroup = styled(MuiButtonGroup)(function (_ref) {
  var _rootStyles;

  var theme = _ref.theme;
  var buttonStyles = {
    borderRadius: pxToRem(10),
    padding: "".concat(pxToRem(10), " ").concat(pxToRem(16))
  };
  var rootStyles = (_rootStyles = {
    borderRadius: pxToRem(12),
    padding: pxToRem(4),
    background: theme.palette.ghostWhite.main,
    border: "".concat(pxToRem(1), " solid ").concat(theme.palette.catskillWhite.main),
    gap: pxToRem(8)
  }, _defineProperty(_rootStyles, ".".concat(buttonGroupClasses.grouped, ":not(:last-of-type)"), buttonStyles), _defineProperty(_rootStyles, ".".concat(buttonGroupClasses.grouped, ":not(:first-of-type)"), buttonStyles), _defineProperty(_rootStyles, ".".concat(buttonGroupClasses.grouped, ".").concat(buttonClasses.text, ":hover"), {
    color: theme.colors.tuna
  }), _rootStyles);
  return rootStyles;
});
export { StyledButtonGroup };